module.exports = __webpack_public_path__ + "img/teuta.0360c201.png";